const KEY = 'viewed_properties';
const PROJECT_KEY = 'viewed_projects';
const MAX = 20;

function push(key: string, id: string) {
  if (!id || typeof window === 'undefined') return;
  try {
    const arr: string[] = JSON.parse(localStorage.getItem(key) || '[]');
    const next = [id, ...arr.filter(x => x !== id)].slice(0, MAX);
    localStorage.setItem(key, JSON.stringify(next));
  } catch { /* ignore */ }
}

function get(key: string): string[] {
  if (typeof window === 'undefined') return [];
  try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; }
}

export function pushRecentlyViewed(id: string) { push(KEY, id); }
export function getRecentlyViewed(): string[] { return get(KEY); }
export function pushRecentlyViewedProject(id: string) { push(PROJECT_KEY, id); }
export function getRecentlyViewedProjects(): string[] { return get(PROJECT_KEY); }
